export const MOP_EVENT_FIELDS = {
  identityName: 'nf_endpoint_name',
  identityId: 'nf_endpoint_id',
  edgeRouterName: 'nf_edge_router_name',
  edgeRouterId: 'nf_edge_router_id',
  serviceName: 'nf_service_name',
  serviceId: 'nf_service_id',
  hostName: 'nf_host_name',
  networkName: 'network_name'
}
